/**
 * E-Mail-Adressen in Fremdtext durch „[Adresse]“ ersetzen. (20.10.2026, Entscheid Schmied zur Kalender-Beschreibung)
 *
 * Beschreibung und Teilnehmernamen kommen aus Einladungen, also von Fremden: Adressen darin gehen weder ans Modell
 * noch in den Verlauf, und die Karte macht daraus keinen mailto:-Link.
 */
const ADRESSE = /[\p{L}\p{N}._%+-]+@[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]+)+/gu;

export function adressenSchwaerzen(text: string): string {
  return text.replace(ADRESSE, "[Adresse]");
}
